{
  "v7.gouvernance.annuler": "Annuler",
  "v7.gouvernance.capacite.aucune_donnee": "Aucune donnée distincte de zéro ce mois-ci.",
  "v7.gouvernance.capacite.choisir": "Choisissez une ligne pour en voir le détail.",
  "v7.gouvernance.capacite.consommation_ia": "Consommation du temps de calcul IA (minutes GPU), jamais la capacité humaine.",
  "v7.gouvernance.capacite.consommees": "Minutes GPU consommées du mois",
  "v7.gouvernance.capacite.detail": "{{missions}} mission(s) active(s) · {{restantes}} min estimées restantes · {{consommees}} min consommées.",
  "v7.gouvernance.capacite.fermer": "Fermer le détail",
  "v7.gouvernance.capacite.liste": "Coût et capacité par projet",
  "v7.gouvernance.capacite.missions": "Missions actives",
  "v7.gouvernance.capacite.mois": "Mois",
  "v7.gouvernance.capacite.mois_choisi": "Mois choisi (UTC).",
  "v7.gouvernance.capacite.mois_courant": "Mois courant (UTC).",
  "v7.gouvernance.capacite.non_ouverts": "{{n}} projet(s) non ouverts (sans nom)",
  "v7.gouvernance.capacite.projet": "Projet",
  "v7.gouvernance.capacite.restantes": "Minutes GPU estimées restantes",
  "v7.gouvernance.capacite.totaux": "Totaux : {{projets}} projet(s), {{missions}} mission(s) active(s), {{restantes}} min estimées restantes, {{consommees}} min consommées.",
  "v7.gouvernance.capacite.totaux_attente": "Totaux en cours de lecture.",
  "v7.gouvernance.capacite.vide": "Aucune consommation ce mois-ci.",
  "v7.gouvernance.code.ACCESS_DENIED": "Accès refusé : vous n’êtes pas membre de ce programme.",
  "v7.gouvernance.code.CONTEXTE_INCOMPLET": "Contexte incomplet : le programme visé n’a pas pu être établi.",
  "v7.gouvernance.code.DROIT_NON_TENU": "Votre profil ne tient pas le droit requis pour ce geste.",
  "v7.gouvernance.code.GARDE_DROIT_ABSENTE": "Opération fermée : aucune garde de droit déclarée.",
  "v7.gouvernance.code.NOT_FOUND": "Introuvable.",
  "v7.gouvernance.code.PROGRAMME_CONFIRMATION_PROJETS_TOUCHES": "Les projets héritiers ont changé depuis votre lecture : relisez la liste et confirmez de nouveau.",
  "v7.gouvernance.code.PROGRAMME_REGLE_HERITEE": "Règle héritée de l’organisation : protégée, elle ne se retire pas au programme.",
  "v7.gouvernance.code.REQUIREMENT_CODE_EXISTS": "Ce code de règle est déjà pris dans ce programme.",
  "v7.gouvernance.code.REQUIREMENT_HAS_WAIVER_HISTORY": "La règle ou une de ses lignes héritées porte l’historique d’une dérogation : elle ne se retire pas.",
  "v7.gouvernance.code.RESOURCE_UNAVAILABLE": "Introuvable dans ce programme (ou hors de votre organisation).",
  "v7.gouvernance.code.SANS_SESSION": "Session absente ou expirée : reconnectez-vous.",
  "v7.gouvernance.code.VALIDATION_ERROR": "Un champ est absent ou hors domaine : corrigez la saisie.",
  "v7.gouvernance.etat.chargement": "Chargement de {{quoi}}…",
  "v7.gouvernance.etat.erreur": "{{quoi}} : lecture impossible pour le moment.",
  "v7.gouvernance.etat.reessayer": "Réessayer",
  "v7.gouvernance.etat.refus": "{{quoi}} : lecture refusée pour ce profil.",
  "v7.gouvernance.evenement.acteur": "Acteur",
  "v7.gouvernance.evenement.action": "Action",
  "v7.gouvernance.evenement.attente": "Séparation des tâches lue avec l’événement.",
  "v7.gouvernance.evenement.cible": "Cible",
  "v7.gouvernance.evenement.correlation": "Corrélation",
  "v7.gouvernance.evenement.correles": "Événements corrélés",
  "v7.gouvernance.evenement.horodatage": "Horodatage",
  "v7.gouvernance.evenement.immuable": "Événement immuable : aucune modification possible.",
  "v7.gouvernance.evenement.integrite": "Intégrité non attestée par une empreinte : contenu sensible expurgé par la passerelle.",
  "v7.gouvernance.evenement.membres": "Membres et habilitations actuelles",
  "v7.gouvernance.evenement.preuve_absente": "Aucune preuve corrélée dans le périmètre du programme.",
  "v7.gouvernance.evenement.preuves": "Preuves",
  "v7.gouvernance.evenement.projet": "Projet",
  "v7.gouvernance.evenement.resultat": "Résultat",
  "v7.gouvernance.evenement.retour_defaut": "Accès direct : le retour ouvre le journal sans filtre.",
  "v7.gouvernance.evenement.retour_filtres": "Retour au journal avec vos filtres et votre position.",
  "v7.gouvernance.evenement.sans_correlation": "Événements corrélés : aucune corrélation pour cet événement.",
  "v7.gouvernance.evenement.separation": "Séparation des tâches",
  "v7.gouvernance.evenement.sod_aucune_decision": "Aucune décision ne se prend ici.",
  "v7.gouvernance.evenement.sod_identiques": "Même personne pour la demande et la décision : signalé.",
  "v7.gouvernance.evenement.sod_insuffisante": "Information historique insuffisante pour identifier demandeur et décideur.",
  "v7.gouvernance.evenement.sod_non_applicable": "Non applicable à cet événement.",
  "v7.gouvernance.evenement.sod_personnes": "Demandeur : {{demandeur}} · décideur : {{decideur}}.",
  "v7.gouvernance.evenement.sod_respectee": "Personnes distinctes : séparation respectée.",
  "v7.gouvernance.evenement.titre_section": "Événement",
  "v7.gouvernance.geste.erreur": "Le geste n’a pas abouti. Réessayez dans un instant.",
  "v7.gouvernance.instance.actions": "Actions",
  "v7.gouvernance.instance.aucune_seance": "Aucune séance tenue.",
  "v7.gouvernance.instance.conclusions": "Conclusions",
  "v7.gouvernance.instance.du_modele": "{{libelle}} — modèle {{modele}}, version {{version}}.",
  "v7.gouvernance.instance.indicateurs": "Indicateurs",
  "v7.gouvernance.instance.ordre_du_jour": "Ordre du jour",
  "v7.gouvernance.instance.participants": "Participants",
  "v7.gouvernance.instance.rien": "Aucun élément.",
  "v7.gouvernance.instance.seance_du": "Séance du {{le}}",
  "v7.gouvernance.instance.seances": "Historique des séances",
  "v7.gouvernance.instance.titre_section": "Instance de gouvernance",
  "v7.gouvernance.instance.vide": "Aucune information pour cette instance.",
  "v7.gouvernance.journal.acteur": "Acteur",
  "v7.gouvernance.journal.action": "Action",
  "v7.gouvernance.journal.appliquer": "Appliquer les filtres",
  "v7.gouvernance.journal.aucun_resultat": "Aucun événement ne correspond aux filtres.",
  "v7.gouvernance.journal.correlation": "Corrélation",
  "v7.gouvernance.journal.dates_inversees": "La fin de la période précède son début : corrigez les dates.",
  "v7.gouvernance.journal.debut": "Début de période",
  "v7.gouvernance.journal.evenements": "Événements du programme",
  "v7.gouvernance.journal.filtres": "Filtres (facultatifs)",
  "v7.gouvernance.journal.fin": "Fin de période",
  "v7.gouvernance.journal.fin_de_liste": "Fin de la liste.",
  "v7.gouvernance.journal.fuseau": "Heure en UTC (fuseau explicite).",
  "v7.gouvernance.journal.ligne": "par {{acteur}} sur {{objet}}",
  "v7.gouvernance.journal.ordre": "{{total}} événement(s), du plus récent au plus ancien ; projets pris au moment de l’action.",
  "v7.gouvernance.journal.ouvrir": "Ouvrir l’événement",
  "v7.gouvernance.journal.page_suivante": "Page suivante",
  "v7.gouvernance.journal.perimetre": "Périmètre : programme {{programme}} seulement, modèle {{modele}} version {{version}}.",
  "v7.gouvernance.journal.perimetre_attente": "Périmètre du programme en cours de lecture.",
  "v7.gouvernance.journal.portee_imposee": "La portée au programme est imposée par la passerelle : aucune entrée de l’organisation hors du programme.",
  "v7.gouvernance.journal.projet_rattache": "projet {{projet}} (rattaché au moment de l’action)",
  "v7.gouvernance.journal.resultat": "Résultat",
  "v7.gouvernance.journal.resultat_echec": "Échec",
  "v7.gouvernance.journal.resultat_refus": "Refus",
  "v7.gouvernance.journal.resultat_succes": "Succès",
  "v7.gouvernance.journal.resultat_tous": "Tous",
  "v7.gouvernance.journal.vide": "Aucun événement pour ce programme.",
  "v7.gouvernance.modele_fige": "Modèle figé du programme : {{libelle}} (version {{version}}).",
  "v7.gouvernance.non_ouverts": "{{n}} projet(s) du programme non ouverts pour vous, comptés sans détail.",
  "v7.gouvernance.onglet.portes": "Portes et comité",
  "v7.gouvernance.onglet.referentiel": "Référentiel du programme",
  "v7.gouvernance.onglets": "Gouvernance du programme",
  "v7.gouvernance.ouvrir_projet": "Ouvrir le projet",
  "v7.gouvernance.portes.choisir": "Choisissez une porte pour en voir les critères et la décision.",
  "v7.gouvernance.portes.decision.ajournee": "ajournée par le comité",
  "v7.gouvernance.portes.decision.franchie": "franchie par le comité",
  "v7.gouvernance.portes.decision.refusee": "refusée par le comité",
  "v7.gouvernance.portes.decision_detail": "Décision : {{decision}} ({{instance}}, séance du {{le}}).",
  "v7.gouvernance.portes.etat.a_venir": "à venir",
  "v7.gouvernance.portes.etat.franchie": "franchie",
  "v7.gouvernance.portes.instances": "Instances du modèle",
  "v7.gouvernance.portes.instances_titre": "Instances de gouvernance",
  "v7.gouvernance.portes.ouvrir_instance": "Ouvrir la fiche : {{libelle}}",
  "v7.gouvernance.portes.revue_mensuelle": "Revue mensuelle, avec son rapport de service.",
  "v7.gouvernance.portes.sans_decision": "Aucune décision du comité pour cette porte.",
  "v7.gouvernance.portes.seances_dans_la_fiche": "Prochaine séance et membres : dans la fiche de l’instance.",
  "v7.gouvernance.portes.titre": "Portes du programme",
  "v7.gouvernance.portes.vide": "Le modèle figé du programme ne définit aucune porte.",
  "v7.gouvernance.regles.ajoutee": "Règle {{code}} ajoutée au programme ; ajout écrit au journal.",
  "v7.gouvernance.regles.ajouter": "Ajouter au programme",
  "v7.gouvernance.regles.ajouter_titre": "Ajouter une règle au programme",
  "v7.gouvernance.regles.artefact": "Référentiel du programme : {{libelle}} (artefact du modèle).",
  "v7.gouvernance.regles.aucun_projet_touche": "Aucun projet n’hérite aujourd’hui de {{code}}.",
  "v7.gouvernance.regles.categorie": "Catégorie",
  "v7.gouvernance.regles.choisir": "Choisissez une règle pour en voir le détail.",
  "v7.gouvernance.regles.code": "Code de la règle",
  "v7.gouvernance.regles.comptes": "{{total}} règle(s) : {{organisation}} de l’organisation, {{propres}} propre(s) au programme, héritées par ses projets.",
  "v7.gouvernance.regles.confirmation": "Confirmation du retrait",
  "v7.gouvernance.regles.confirmer_retrait": "Confirmer le retrait",
  "v7.gouvernance.regles.controle": "Contrôle",
  "v7.gouvernance.regles.detail": "Catégorie {{categorie}} · contrôle {{controle}} · seuil {{seuil}}",
  "v7.gouvernance.regles.dod": "Critère de fin (DoD)",
  "v7.gouvernance.regles.enonce": "Énoncé",
  "v7.gouvernance.regles.etat.a_verifier": "à vérifier",
  "v7.gouvernance.regles.etat.conforme": "conforme",
  "v7.gouvernance.regles.etat.en_derogation": "en dérogation",
  "v7.gouvernance.regles.etat.non_conforme": "non conforme",
  "v7.gouvernance.regles.etat.perimee": "périmée",
  "v7.gouvernance.regles.heritee": "héritée de l’organisation",
  "v7.gouvernance.regles.incomplet": "Code, énoncé et contrôle sont obligatoires.",
  "v7.gouvernance.regles.jamais_plus_faible": "Une règle du programme renforce celle de l’organisation, jamais plus faible : la passerelle le vérifie.",
  "v7.gouvernance.regles.nature": "Nature",
  "v7.gouvernance.regles.nfr": "Exigence non fonctionnelle",
  "v7.gouvernance.regles.projets_touches": "Retirer {{code}} retire aussi la règle de ces {{n}} projet(s) héritier(s) :",
  "v7.gouvernance.regles.propre": "propre au programme",
  "v7.gouvernance.regles.protegee": "Règle héritée de l’organisation : protégée, elle se retire à l’organisation, jamais au programme.",
  "v7.gouvernance.regles.retiree": "Règle {{code}} retirée du programme et de {{n}} projet(s) ; retrait écrit au journal.",
  "v7.gouvernance.regles.retirer": "Retirer la règle du programme",
  "v7.gouvernance.regles.seuil": "Seuil (facultatif)",
  "v7.gouvernance.regles.titre": "Règles du programme",
  "v7.gouvernance.regles.vide": "Aucune règle : les projets suivent le référentiel de l’organisation.",
  "v7.gouvernance.retour_journal": "Retour au journal",
  "v7.gouvernance.retour_portes": "Retour aux portes et au comité",
  "v7.gouvernance.retour_programme": "Retour au programme",
  "v7.gouvernance.roadmap.choisir": "Choisissez un jalon pour voir ses projets et versions.",
  "v7.gouvernance.roadmap.etat_jalon.en_retard": "en retard",
  "v7.gouvernance.roadmap.etat_jalon.livre": "livrée",
  "v7.gouvernance.roadmap.etat_jalon.non_date": "non datée",
  "v7.gouvernance.roadmap.etat_jalon.prevu": "prévue",
  "v7.gouvernance.roadmap.fiche_repere": "Fiche du repère",
  "v7.gouvernance.roadmap.jalon": "Jalon {{version}}",
  "v7.gouvernance.roadmap.jalons": "Jalons et versions",
  "v7.gouvernance.roadmap.points": "{{fait}} / {{engage}} points",
  "v7.gouvernance.roadmap.produit": "Feuille de route produit",
  "v7.gouvernance.roadmap.produit_vide": "Aucune feuille de route produit pour ce programme.",
  "v7.gouvernance.roadmap.projet_resume": "{{epics}} epic(s), {{retard}} en retard, {{versions}} version(s)",
  "v7.gouvernance.roadmap.retard_signale": "retard signalé",
  "v7.gouvernance.roadmap.sprints": "Roadmap des projets du programme",
  "v7.gouvernance.roadmap.statut.active": "en cours",
  "v7.gouvernance.roadmap.statut.closed": "clos",
  "v7.gouvernance.roadmap.statut.planned": "planifié",
  "v7.gouvernance.roadmap.vide": "Aucun sprint planifié dans les projets du programme.",
  "v7.gouvernance.sans_programme": "Aucun programme choisi : choisissez un programme dans le sélecteur de contexte.",
  "v7.gouvernance.suivi.artefact": "{{libelle}} : produit par le programme.",
  "v7.gouvernance.suivi.artefacts": "Artefacts produits par le programme",
  "v7.gouvernance.suivi.aucun_rapport": "Aucun rapport lu.",
  "v7.gouvernance.suivi.contribution": "Contribution du projet choisi",
  "v7.gouvernance.suivi.csv": "Exporter en CSV",
  "v7.gouvernance.suivi.csv_ok": "Fichier {{nom}} produit.",
  "v7.gouvernance.suivi.epics": "Epics terminés / total",
  "v7.gouvernance.suivi.etat.aucun_projet": "aucun projet",
  "v7.gouvernance.suivi.etat.dans_les_temps": "dans les temps",
  "v7.gouvernance.suivi.etat.donnees_insuffisantes": "données insuffisantes",
  "v7.gouvernance.suivi.etat.en_retard": "en retard",
  "v7.gouvernance.suivi.etat.sans_cible": "sans cible",
  "v7.gouvernance.suivi.etat.termine": "terminé",
  "v7.gouvernance.suivi.impact.high": "impact élevé",
  "v7.gouvernance.suivi.impact.low": "impact faible",
  "v7.gouvernance.suivi.impact.medium": "impact moyen",
  "v7.gouvernance.suivi.imprimer": "Imprimer ou enregistrer en PDF",
  "v7.gouvernance.suivi.par_projet": "Avancement par projet et par jalon",
  "v7.gouvernance.suivi.projet": "Projet",
  "v7.gouvernance.suivi.rapport": "Rapport d’avancement",
  "v7.gouvernance.suivi.rapport_du": "Rapport du {{le}}",
  "v7.gouvernance.suivi.rapports": "Rapports par période",
  "v7.gouvernance.suivi.risques": "{{n}} risque(s) ouvert(s), dont {{hauts}} élevé(s)",
  "v7.gouvernance.suivi.sprint": "Sprint actif (fait / engagé)",
  "v7.gouvernance.suivi.synthese": "Synthèse : {{etat}} · date probable {{date}} · jalon cible {{cible}}.",
  "v7.gouvernance.suivi.version": "Version (en préparation ou livrée)",
  "v7.gouvernance.suivi.vide": "Aucun projet dans le programme : rien à suivre.",
  "v7.gouvernance.titre.capacite": "Coût et capacité du programme",
  "v7.gouvernance.titre.evenement": "Détail d’un événement du programme",
  "v7.gouvernance.titre.gouvernance": "Gouvernance et standards — référentiel du programme",
  "v7.gouvernance.titre.instance": "Étape de gouvernance du programme",
  "v7.gouvernance.titre.journal": "Journal d’audit du programme",
  "v7.gouvernance.titre.portes": "Gouvernance et standards — portes et comité",
  "v7.gouvernance.titre.roadmap": "Roadmap du programme",
  "v7.gouvernance.titre.suivi": "Suivi de l’avancement du programme"
}
